<template lang="pug">
  .job-menu(:class="{ active: checked || isUploaded || isUploading }")
    p(v-if="checkedCount > 0")
      span(v-if="spMode") {{ checkedCount }}件のリストを選択
      span(v-else) {{ checkedCount }}件のリストを一覧から選択しています。
      span
        a(@click="uncheckAll") チェック解除
    p.more-dl-message(v-if="checkedCount > 0")
      | 1度のダウンロードは1,000件までできます
      span(v-if="leadManagementShareButton")
        | 取引先の追加は600件までできます
    ul
      li
        a.only-pc.button-sub(
          v-if="checkedCount > 0"
          @click="openCsvDownloadModal"
          :disabled="disabled"
        ) ダウンロード

      li(v-if="leadManagementShareButton && checkedCount > 0")
        a.button-sub(
          @click="openAddAccountModal"
          :class="{ disabled: checkedCount > 600 }"
        ) 取引先追加
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { HumanErrorMessages } from '../../constants'

export default {
  props: ['leadManagementShareButton'],
  computed: {
    ...mapGetters('jobMark', ['checked', 'checkedCount', 'checkedIds']),
    ...mapGetters('common', ['spMode', 'downloading']),
    ...mapGetters('user', ['demo']),
    ...mapGetters('uploadArchive', ['isUploading', 'isUploaded']),
    ...mapGetters({ locked: 'common/isGlobalLocked' }),
    disabled () {
      return this.locked || this.downloading
    },
  },
  async mounted () {
    try {
      await this.$store.dispatch('uploadArchive/fetchLatest', { target: 'company_list' })
      if (this.isUploading) await this.$store.dispatch('uploadArchive/startWatch', { target: 'company_list' })
    } catch (e) {
      // 無視
    }
    if (this.isUploading) this.$store.dispatch('uploadArchive/startWatch', { target: 'company_list' })
  },
  methods: {
    ...mapActions('jobMark', ['removeCheckedCompanies']),
    ...mapMutations('jobMark', ['uncheckAll']),

    openCsvDownloadModal () {
      // モーダルで company_ids を使う前提のため、既存踏襲
      this.$store.commit('company/copyCheckedIds', this.checkedIds)

      if (this.demo) {
        this.$store.dispatch('common/pushToastError', {
          error: new Error(HumanErrorMessages.FORBIDDEN),
        })
        return
      }
      if (this.isUploading) return

      if (this.checkedCount > 0) {
        this.$store.commit('common/setCsvTarget', 'company_list')
        this.$store.commit('common/setCompanyModalMode')
        this.$store.commit('common/showModal')
      }
    },

    async downloadFromS3 () {
      try {
        await this.$store.dispatch('uploadArchive/download', { target: 'company_list' })
      } catch (e) {
        await this.$store.dispatch('common/pushToastError', { error: e })
      }
    },

    async openAddAccountModal () {
      if (this.checkedCount > 0) {
        await this.$store.dispatch('account/showModal', this.checkedIds)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/parts/CompanyListMenu.vue